import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import styles from './styles.scss'
const cx = classnames.bind(styles)

const Header = ({ elmId, title, subtitle }) => (
  <div className={cx('event-header-container')}>
    <h1 className={cx('event-title')} data-elm-id={elmId + '_title'}>
      {title}
    </h1>
    <h3 className={cx('event-subtitle')} data-elm-id={elmId + '_subtitle'}>
      {subtitle}
    </h3>
  </div>
)

Header.propTypes = {
  elmId: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
}

export default Header
